<template>
  <section id="corporate" class="corporate">
    <div class="container" data-aos="fade-up">
      <div class="row">
        <div class="col-lg-6 mt-5 mt-lg-0 corporate-img align-items-stretch">
          <img src="assets/img/corporate.png" alt="corporate" width="250">
        </div>
        <div class="col-lg-6 mt-5 mt-lg-0 d-flex align-items-stretch">
          <div class="corporate">
            <h2 style="color: #FFFFFF;text-transform: uppercase;font-weight: bold;">Corporate Top-Up</h2>
            <p>It is our pleasure and privilege to offer the most exclusive and advanced payment solutions for your highly esteemed organization. We would like to propose you a solution to pay your employees’ mobile phone bills as well as other utility bills from a single platform, namely Winfin.</p>
            <p>Our offer will give you flexibility, reliability and cost-saving altogether in an unmatched way. The unique features and supporting services of carefully designed Payment Solutions offer will surely give a competitive edge to your organization in terms of communications and operational efficiency.</p>
          </div>
        </div>
        <div class="col-lg-12 mt-5 mt-lg-0 align-items-stretch benefits">
          <h3>What are the benefits of choosing Winfin as your payment service solution?</h3>
          <div class="row">
            <div class="col-lg-4 mt-2 mb-2" >
              <div class="benefit-1 align-items-start" data-aos="zoom-in" data-aos-delay="100">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="info">
                      <img src="assets/img/computer.png" alt="benefit one" width="100">
                      <p>Any mobile bills (prepaid/postpaid) bills payment from the convenience of your office desktops.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mt-2 mb-2">
              <div class="benefit-1 align-items-start" data-aos="zoom-in" data-aos-delay="100">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="info">
                      <img src="assets/img/discount.png" alt="benefit two" width="100">
                      <p>A discount of 2.0% on the total bill amount on the successful agreement.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mt-2 mb-2">
              <div class="benefit-1 align-items-start" data-aos="zoom-in" data-aos-delay="100">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="info">
                      <img src="assets/img/report.png" alt="benefit three" width="100">
                      <p>Availability of downloadable reports on successful failed or total bills payment for finance reconciliation.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="corporate-client">
        <h2>Be our corporate client today</h2>
        <a target="_blank" href="http://portal.winfinbd.com/register" class="btn btn-primary">Corporate Sign Up</a>
      </div>
    </div>
  </section>
  <!-- End Contact Section -->
</template>
<script>
export default {
  name: "CorporateTopUp",
};
</script>

<style scoped lang="scss">
.corporate {
  text-align: justify;
  background: #8f2d56;
}
.corporate .section-title>h2 {
  color: #FFFFFF;
}
.section-title h2::after {
  background: #FFFFFF;
}
.corporate p,ul {
  color: #FFFFFF;
}
.benefits {
  padding-top: 70px;
}
.benefits h3 {
  font-size: 30px;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
}
.benefits > .row {
  margin-top: 40px;
}
.corporate-img {
  text-align: center;
}
.info {
  text-align: center;
}
.info p {
  padding: 25px 0;
  font-size: 20px;
}
.corporate-client {
  margin-top: 20px;
  text-align: center;
}
.corporate-client h2 {
  color: #FFFFFF;
  font-size: 50px;
  text-transform: capitalize;
  font-weight: bold;
}
.corporate-client a {
  margin-top: 30px;
  background: #004a59;
  border: none;
  width: 220px;
  padding: 18px;
  border-radius: 35px;
  text-transform: uppercase;
  font-weight: bold;
}
</style>
